import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

interface UsePageOptions {
  onInView: () => void;
}

const usePage = ({ onInView }: UsePageOptions) => {
  const { ref: observerRef, inView } = useInView({
    threshold: 1,
    rootMargin: "10px 20px 30px 40px",
  });

  const [page, setPage] = useState(0);

  const resetPage = () => {
    setPage(0);
  };

  const addPage = () => {
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    if (!inView) return;
    onInView();
  }, [inView]);

  return { page, resetPage, observerRef, addPage };
};

export default usePage;
